import { render, staticRenderFns } from "./zsdzd.vue?vue&type=template&id=025dbbf6&scoped=true&"
import script from "./zsdzd.vue?vue&type=script&lang=js&"
export * from "./zsdzd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025dbbf6",
  null
  
)

export default component.exports